import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import { v4 as uuidv4 } from 'uuid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import Bs4I18N from '../Bs4I18N';

import {useDroppable} from '@dnd-kit/core';
import { useDraggable } from '@dnd-kit/core';
import { IconButton, Typography } from '@mui/material';
import Bs4FormElement from './Bs4FormElement'

export class Bs4FormElementDraggable extends Bs4FormElement {
  constructor(element) {
    super({});
    this.element = element;
    [this.id, this.etykieta, this.opis, this.ikonaAkronim, this.kolor] = element;
    this.key = 'Bs4FormDraggableElement_'+this.id;
    this.formElementType = (() => {switch (this.id) {case '50': return 3; case '7': return 2; default: return 1;}})();
  }

  original = null;

  getFormElementSize = () => null;  

  draggableId = uuidv4();
  setDraggableId = () => {
    console.log('=== Error === setDraggableId not implemented');
  }

  ViewComponent = (props) => {
    const form = this;  
    const [draggableId, setDraggableId] = React.useState(this.draggableId)
    const {attributes, listeners, setNodeRef, setActivatorNodeRef, transform, node} = useDraggable({
      id: this.draggableId, //this.key,
      data: {
        formElement: this, 
        type: 'form',
        add: true,
      },   
    });

    const {activeCurrent} = React.useContext(this.bs4Form.activeCurrentContext);

    const sxGrill = React.useMemo(() => {
      if (activeCurrent?.formElement === this) return this.getGrilleBox(2);
      return {}      
    }) 

    React.useEffect(() => {
      this.setDraggableId = () => {
        this.draggableId = uuidv4();
        setDraggableId(this.draggableId);
        console.log('...SET...List.Draggable..', form.etykieta, this.draggableId);
      }
    }, [setDraggableId])
    
    //console.log('...List.Draggable..', form.etykieta, this.draggableId, draggableId);

    return (
      <ListItem
        dense 
        disableGutters 
        ref={setNodeRef} 
        {...listeners}
        id={form.key}
        // {...attributes}
        sx={{cursor: 'grab', ...sxGrill}} //pointer
      >
        <ListItemIcon sx={{justifyContent:'center', minWidth: 32,}}><i className={form.ikonaAkronim}/></ListItemIcon>
        <ListItemText primary={form.etykieta} secondary={form.opis}/>
      </ListItem>
    )
  }  
}

const Bs4FormElementDraggableDelete = (props) => {  
  const elements = React.useMemo(() => (props.dragDropSection || [])
  // .filter(([id, etykieta, opis, ikonaAkronim, kolor]) => String(id) !== '50') //Pomija szpaltę
  .map(element => {
    const draggableElement = new Bs4FormElementDraggable(element);
    draggableElement.bs4Form = props.bs4Form;
    return draggableElement;
  }), [props.dragDropSection, props.bs4Form]);

  const { isOver, setNodeRef, node } = useDroppable({
    id: 'Bs4FormElementDraggableDelete',
    data: {formElement: {      
      formElementType: 998,
      colisionBefore: false,
      type: 'form',
    }}
  });

  return (      
    <Stack
      ref={setNodeRef} 
      direction="column"
      spacing={2}
      sx={{
        justifyContent: "center",
        alignItems: "center",
        width: '100%',
      }}
    >
      <Stack         
        direction="row" 
        spacing={1} 
        sx={{
          // justifyContent: "space-between", 
          justifyContent: "flex-start",
          alignItems: "center",         
          paddingX: 2, 
          paddingY: 1,         
          width: '100%',
        }}
      >        
        <i className="fa-solid fa-trash"></i>
        <Typography sx={{fontWeight: 'bold'}}>{'Usuń element'}</Typography>      
      </Stack>    
      <Box sx={{padding: 2, display: isOver ? 'block' : 'none' }}>
        <i className="fa-solid fa-trash" style={{fontSize: '64px'}}></i>
      </Box>
    </Stack>
  );
}

export const Bs4FormElementDraggableList = (props) => {  
  const elements = React.useMemo(() => (props.dragDropSection || [])
  // .filter(([id, etykieta, opis, ikonaAkronim, kolor]) => String(id) !== '50') //Pomija szpaltę
  .map(element => {
    const draggableElement = new Bs4FormElementDraggable(element);
    draggableElement.bs4Form = props.bs4Form;
    return draggableElement;
  }), [props.dragDropSection, props.bs4Form]);

  const { isOver, setNodeRef, node } = useDroppable({
    id: 'Bs4FormElementDraggableList',
    data: {formElement: {      
      formElementType: 999,
      colisionBefore: false,
      type: 'form',
    }}
  });
  
  if (!props.addNew) return null;
  
  return (      
    <Box 
      // ref={setNodeRef}
      height='100%' 
      display='flex' 
      flexDirection='column' 
      overflow='hidden'
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2} sx={{paddingX: 2, paddingY: 1}}>
        <Stack direction="row" spacing={1} sx={{justifyContent: "flex-start", alignItems: "center"}}>
          <i className="fa-solid fa-list-ul"></i>
          <Typography sx={{fontWeight: 'bold'}}>{'Lista'}</Typography>
        </Stack>
        <IconButton onClick={(event) => props.onClose(event)}><i className="fa-solid fa-xmark"/></IconButton>
      </Stack>
      <Box
        ref={setNodeRef}
        flex={1}
        overflow='auto'
        display='flex' 
        flexDirection='column'
        padding={1}
      >        
        {elements.map((element) => {          
          return (
            <element.ViewComponent key={element.key}/>
          )
        })}
      </Box>
      <Bs4FormElementDraggableDelete/>      
    </Box>
  );
}

export default Bs4FormElementDraggableList;